import { useMemo } from 'react';

import { useLabelingBoxContext } from '@/provider';
import type { BoxWithLabel } from '@/type';

import useToolPcdCanvasContext from './useToolPcdCanvasContext';

const useTargetLabelingBoxList = () => {
  const { isViewMode } = useToolPcdCanvasContext();
  const { labelingBoxList, selectedBoxIdMap } = useLabelingBoxContext();

  return useMemo(() => {
    const boxList = labelingBoxList;

    if (isViewMode.default) return boxList.map(b => b.toJSON() as BoxWithLabel);

    const result = Object.values(selectedBoxIdMap).some(v => v)
      ? boxList
          // .filter(box => selectedBoxIdMap[box.id.value!])
          .filter(box => selectedBoxIdMap[box.id])
          .slice(0, 1)
          .map(b => b.toJSON() as BoxWithLabel)
      : [];

    return result;
  }, [isViewMode, labelingBoxList, selectedBoxIdMap]);
};

export default useTargetLabelingBoxList;
